export const links = [
    {
      name: "About",
      submenu: true,
      sublinks: [
        {
          Head: "Our School",
          sublink: [
            { name: "About us", link: "about/" },
            { name: "Our Team", link: "our-team/" },            
            { name: "Our facilities", link: "/" },
            { name: "Careers", link: "/" },
            { name: "News&Media", link: "/" },


          ],
        },
        {
          Head: "Registration",
          sublink: [
            { name: "Forms for registration", link: "/" },
            { name: "Parents Handbook", link: "/" },
            { name: "Health & Safety", link: "/" },
          ],
        },
       
      ],
    },
    {
      name: "Classes",
      submenu: true,
      sublinks: [
        {
          Head: "Our classes",
          sublink: [
            { name: "Ballet", link: "/" },
            { name: "Jazz/Hip Hop", link: "/" },
            { name: "Tap", link: "/" },
          ],
        },
        {
          Head: "Info",
          sublink: [
            { name: "Fees", link: "/" },
            { name: "Schedule", link: "/" },
            { name: "Calendar", link: "/" },
          ],
        },
     
        // {
        //   Head: "footwear",
        //   sublink: [
        //     { name: "T-shirt", link: "/" },
        //     { name: "Casual shirts", link: "/" },
        //     { name: "formal shirts", link: "/" },
        //     { name: "formal shirts", link: "/" },
        //     { name: "formal shirts", link: "/" },
        //   ],
        // },
      ],
    },
    {
      name: "Gallery",
      submenu: true,
      sublinks: [
        {
          Head: "Photos",
          sublink: [
            { name: "Recitals", link: "/" },
            { name: "Level 1 Ballet and Up", link: "/" },
            { name: "Youth Ballet", link: "/" },
            { name: "Creative Ballet", link: "/" },
            { name: "Preschool Dance", link: "/" },
            { name: "Kinder Dance", link: "/" },
          ],
        },
        
      ],
    },
  ];